// extracted by mini-css-extract-plugin
module.exports = {"container":"ClientsView_container__1xFJH"};